import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import quoteDetailAPICallResponseMaker from "src/service/QuoteDetailAPICall/quoteDetailAPICallResponseMaker";
import { __remove, __set } from "../../axios_indicator";
import QuoteDetailRepository from "../../../repository/QuoteDetailRepository";
import { isObject, isString } from "underscore";
import produceClone from "../../../helper/produceClone";
import System from "src/helper/system";
import liveAuth from "src/helper/liveAuth";

const initialState = new quoteDetailAPICallResponseMaker().defaultValue();

export const getHeaderDetail = createAsyncThunk('quote_detail_get_header_detail', async (params) => {
    __set('QUOTE_DETAIL_API_CALL');
    return await new QuoteDetailRepository().getHeaderDetail(params.quoteNumber, params.quoteProvisionalNumber)
});
export const getLineItemsDetail = createAsyncThunk('quote_detail_get_line_item_details', async (params) => {
    __set('LINE_ITEM_API_CALL');
    return await new QuoteDetailRepository().getLineItemsDetail(params)
});
export const getApprovedQuotes = createAsyncThunk('quote_detail_approved_list', async(params) => {
    return await new QuoteDetailRepository().getApprovedQuoteList(params)
});

const storage_name = 'QuoteCartActiveSession' + '__' + System.getCurrentSiteSpeedboat();
const avUserInfo = liveAuth.getAvUserInfo()
const metaData = avUserInfo?.account;
const storage_meta_info = "QuoteCartActiveAccount"


const setAllToLocalStorage = (data) => {
    data = produceClone(data);
    sessionStorage.setItem(storage_meta_info, metaData ? metaData?.accountNumber : metaData)
    sessionStorage.setItem(storage_name, JSON.stringify(data.cart_quote_active_session))
};

const getAllToLocalStorage = () => {
    const getMetaData = sessionStorage.getItem(storage_meta_info);
    const accountObj = System.auth('account');
    if (accountObj && isObject(accountObj) && accountObj?.accountNumber === getMetaData) {
        let l_h = sessionStorage.getItem(storage_name)
        if (l_h && l_h !== 'undefined') {
            return JSON.parse(l_h);
        }
    } else {
        const data = initialState.cart_quote_active_session
        setAllToLocalStorage(data)
    }
    return initialState.cart_quote_active_session;
};

const slice = createSlice({
    name: "QuoteDetail",
    initialState: { ...initialState, ...{ cart_quote_active_session: getAllToLocalStorage() } },
    reducers: {
        toggle_quote_cart_line_item: {
            reducer: (state, action) => {
                let s = {};
                let p_d = action.payload.data;
                if (state.cart_quote_active_session[p_d.quoteNumber] !== undefined) {
                    s = state.cart_quote_active_session[p_d.quoteNumber];
                }
                if (s.records === undefined) {
                    s.records = {};
                }
                s.records[p_d.uniqueLineItem] = p_d;
                if (p_d.quantity_field_selected === undefined ||
                    p_d.quantity_field_selected === false) {
                    delete s.records[p_d.uniqueLineItem];
                }
                state.cart_quote_active_session[p_d.quoteNumber] = s;
                setAllToLocalStorage(state);
                return state;
            },
        },
        remove_all_quote_number_based_cart_quote_active_session: {
            reducer: (state, action) => {
                let p_d = action.payload.data;
                delete state.cart_quote_active_session[p_d.quoteNumber];
                setAllToLocalStorage(state)
                return state;
            },
        },
        destroy_cart_quote_active_session: {
            reducer: (state, action) => {
                state.cart_quote_active_session = initialState.cart_quote_active_session;
                setAllToLocalStorage(state)
                return state;
            },
        },
        remove_quote_cart_line_item: {
            reducer: (state, action) => {

                let s = {};
                let p_d = action.payload;
                if (state.cart_quote_active_session[p_d.quoteNumber] !== undefined) {
                    s = state.cart_quote_active_session[p_d.quoteNumber];
                }
                if (s.records === undefined) {
                    s.records = {};
                }
                if (s.records[p_d.uniqueLineItem] !== undefined) {
                    delete s.records[p_d.uniqueLineItem];
                }
                state.cart_quote_active_session[p_d.quoteNumber] = s;
                setAllToLocalStorage(state)
                return state;
            },
        },
        select_all_quantity: {
            reducer: (state, action) => {
                let s = {};
                let quoteNumber = action.payload.quoteNumber;
                if (state.cart_quote_active_session[quoteNumber] !== undefined) {
                    s = state.cart_quote_active_session[quoteNumber];
                }
                s.records = action.payload.list;
                state.cart_quote_active_session[quoteNumber] = s;
                setAllToLocalStorage(state);
                return state;
            },
        },
        set_schedule_date: {
            reducer: (state, action) => {
                let s = {};
                let p_d = action.payload;
                let quoteNumber = p_d.quoteNumber;
                if (state.cart_quote_active_session[quoteNumber] !== undefined) {
                    s = state.cart_quote_active_session[quoteNumber];
                }
                s.records[p_d.uniqueLineItem].scheduleDetails = p_d.shipmentDetails
                state.cart_quote_active_session[quoteNumber] = s;
                setAllToLocalStorage(state);
                return state;
            },

        }
    },
    extraReducers: {
        [getHeaderDetail.fulfilled]: (state, { payload }) => {
            __remove('QUOTE_DETAIL_API_CALL');
            return merge_payload_to_state(state, payload, "header");
        },
        [getLineItemsDetail.fulfilled]: (state, { payload }) => {
            __remove('LINE_ITEM_API_CALL');
            return merge_payload_to_state(state, payload);
        },
        [getApprovedQuotes.fulfilled]: (state, { payload }) => {
           state.quote_approved_list = payload?.quoteLines?.quoteLineItems
           return state;
        }
    },
});

function merge_payload_to_state(state, payload, from = "line_items") {
    let data = payload.data;

    if (from !== "line_items") {

        Object.entries(initialState).map((v) => {
            if (v[0] !== 'line_items' && v[0] !== 'cart_quote_active_session' && data && data !== undefined && data[v[0]] && data[v[0]] !== undefined) {
                if (isString(data[v[0]])) {
                    state[v[0]] = data[v[0]].trim();
                } else {
                    state[v[0]] = data[v[0]];
                }
            }
        });

    }

    if (state.line_items === undefined) {
        state.line_items = {};
    }
    if (state.line_items !== undefined && state.line_items[data.line_items_axios_fetch_slug] === undefined &&
        data.line_items_axios_fetch_slug !== false
    ) {
        state.line_items[data.line_items_axios_fetch_slug] = {
            count: 0
        };
    }
    if (data.line_items_axios_fetch_slug !== undefined && data.line_items_axios_fetch_slug) {
        state.line_items[data.line_items_axios_fetch_slug] = data.line_items[data.line_items_axios_fetch_slug];
    }
    if (data.line_items_axios_fetch_slug !== undefined && data.line_items_axios_fetch_slug === false &&
        isObject(data.line_items) && Object.entries(data.line_items).length > 0
    ) {
        Object.entries(data.line_items).map((v) => {
            if (state.line_items[v[0]] === undefined) {
                state.line_items[v[0]] = {
                    count: 0
                };
            }
            else {
                // 11954 - DT - 31May23 whn no records in filter
                if (state.line_items[v[0]].count != v[1].count) {
                    state.line_items[v[0]] = v[1];
                }
                // DT 9075 - 15May23 for tab count
                // if (state.line_items[v[0]].count > 0) {
                // // donot update count
                // }else{ 
                //     state.line_items[v[0]] = v[1];
                // }
            }
            // state.line_items[v[0]] = v[1]; // DT 9075 - 15May23 for tab count
        })
    } else {
        // set count
        if (isObject(data.line_items) && Object.entries(data.line_items).length > 0 && state.line_items !== undefined && state.line_items[data.line_items_axios_fetch_slug]) {
            Object.entries(data.line_items).map((v) => {
                if (state.line_items[v[0]] === undefined) {
                    state.line_items[v[0]] = { count: 0 };
                } else {
                    // state.line_items[v[0]].count = v[1].count;
                    if (state.line_items[v[0]].count != v[1].count) {
                        state.line_items[v[0]] = v[1];
                    }
                }
            })
        }
    }

    return state;
}

export let { toggle_quote_cart_line_item, destroy_cart_quote_active_session, remove_all_quote_number_based_cart_quote_active_session, remove_quote_cart_line_item, select_all_quantity, set_schedule_date } = slice.actions;

export default slice.reducer;
